import { useIntl } from "react-intl";
import React, { useRef, useEffect, useState, useMemo } from "react";
import { Input, Dropdown, Icon } from "semantic-ui-react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
// import TreeItem from "@mui/lab/TreeItem";
// import TreeView from "@mui/lab/TreeView";
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';

import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchBox from "react-lib/apps/common/SearchBox";

const TreatmentItem = (props: any) => {
  const intl = useIntl();
  const doctorRef = useRef();
  const divisionRef = useRef();
  const abortController = useRef<AbortController>(null);
  let timer: any;

  const [denTreatmentData, setDenTreatmentData] = useState<any>({});
  const [searchTreatment, setSearchTreatment] = useState<string>("");
  const [toggleTreatmentList, setToggleTreatmentList] = useState<any[]>([]);
  const [selectTreatment, setSelectTreatment] = useState<string>("");

  useEffect(() => {
    if (searchTreatment.length === 0 || searchTreatment.length > 2) {
      const timer = setTimeout(() => {
        handleGetTreatmentSearchOptions();
      }, 1500);
      return () => clearTimeout(timer)
    }
  }, [searchTreatment]);

  useEffect(() => {
    setDenTreatmentData({ id: "root", name: "", children: props.dentalTreatmentList });
  }, [props.dentalTreatmentList]);

  useEffect(() => {
    if (selectTreatment === "") {
    } else if (toggleTreatmentList.includes(selectTreatment)) {
    } else {
      const optionsName: any[] = getOptionsName(denTreatmentData) || [];
      const result = optionsName.flat(4).filter((n) => n);

      if (result.length > 0) {
        (document.querySelector(`.ui.modals #tree-view-${props.index}`) as HTMLDivElement)?.blur();

        setSearchTreatment("");
        setToggleTreatmentList([]);
        setSelectTreatment("");
        props.setProp(`treatmentPlanList.${props.index}`, { ...props.item, treatment: selectTreatment, treatment_label: result[0] });
      }
    }
  }, [toggleTreatmentList, selectTreatment]);

  const statusOptions = useMemo(
    () => (props.readonly ? props.allStatusOptions : props.statusOptions),
    [props.allStatusOptions, props.readonly, props.statusOptions]
  );

  const handleGetDoctorSearchOptions = async ({ searchText = "" }) => {
    return await props.onEvent({ message: "GetDoctorSearch", params: { search: searchText, lang: "th" } });
  };

  const handleOnSelectedDoctor = ({ item, id }: any) => {
    props.setProp(`treatmentPlanList.${props.index}`, { ...props.item, doctor: id, doctor_full_name: item.full_name });
  };

  const handleGetDivisionSearchOptions = async ({ searchText = "" }) => {
    return await props.onEvent({ message: "GetDivisionSearch", params: { name_code_contains: searchText } });
  };

  const handleOnSelectedDivision = ({ item, id }: any) => {
    props.setProp(`treatmentPlanList.${props.index}`, { ...props.item, division: id, division_label: item.name_code });
  };

  const handleChangeDivision = (textValue: any) => {
    if (textValue === "") {
      props.setProp(`treatmentPlanList.${props.index}`, { ...props.item, division: null, division_label: "" });
    } else {
      props.setProp(`treatmentPlanList.${props.index}`, { ...props.item, division: null, division_label: textValue });
    }
  };

  const handleChangeDoctor = (textValue: any) => {
    if (textValue === "") {
      props.setProp(`treatmentPlanList.${props.index}`, { ...props.item, doctor: null, doctor_full_name: "" });
    } else {
      props.setProp(`treatmentPlanList.${props.index}`, { ...props.item, doctor: null, doctor_full_name: textValue });
    }
  };

  // Dental Treatment
  const handleGetTreatmentSearchOptions = () => {
    // cancel the previous in-flight search before firing the latest one
    abortController.current?.abort();
    props.onEvent({
      message: "GetTreatmentSearchList",
      params: {
        abortController,
        search: searchTreatment,
        no_parent: searchTreatment?.length === 0 ? "true": "false"
      },
    });
  };

  const handleSearchDentalTreatment = (_event: React.SyntheticEvent, value: string, reason: string) => {
    if (reason === "input") {
      setSearchTreatment(value);
      props.setProp(`treatmentPlanList.${props.index}`, { ...props.item, treatment: null, treatment_label: value });
    }
  };

  const handleDentalTreatmentToggle = (_event: React.SyntheticEvent, nodeIds: any[]) => {
    setToggleTreatmentList(nodeIds);
  };

  const handleDentalTreatmentSelect = (_event: React.SyntheticEvent, nodeIds: string) => {
    setSelectTreatment(nodeIds);
  };

  const getOptionsName = (nodes: any) => {
    if (nodes.id === selectTreatment) {
      return nodes.name;
    }
    return nodes.children.length > 0 ? nodes.children.map((node: any) => getOptionsName(node)) : null;
  };

  const renderTree = (nodes: any) => {
    return (
      <TreeItem key={nodes.id} nodeId={nodes.id} label={nodes.name}>
        {Array.isArray(nodes.children) ? nodes.children.map((node: any) => renderTree(node)) : null}
      </TreeItem>
    );
  };

  // console.log("TreatmentItem props: ", searchTreatment, props.item.treatment_label, denTreatmentData)
  return (
    <div style={{ padding: "5px", border: "solid #cccccc 1px", backgroundColor: "#eeeeee", marginBottom: "10px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ flex: 3, display: "flex", flexDirection: "column", paddingRight: "5px" }}>
          <div style={{ padding: "5px 0" }}>{intl.formatMessage({ id: "cukey293" })}</div>

          <Autocomplete
            id={`tree-view-${props.index}`}
            disablePortal
            disabled={props.readonly}
            size="small"
            sx={{ background: props.readonly ? "rgba(255,255,255,0.38)" : "white" }}
            // input
            renderInput={(params) => <TextField error={props.errorTreatment[props.index]} {...params} variant="outlined" />}
            inputValue={searchTreatment || props.item.treatment_label || ""}
            onInputChange={handleSearchDentalTreatment}
            // options
            options={[props.item.treatment_label || searchTreatment || ""]}
            renderOption={() => (
              <TreeView
                aria-label="rich object"
                defaultCollapseIcon={<ExpandMoreIcon />}
                defaultExpanded={["root"]}
                defaultExpandIcon={<ChevronRightIcon />}
                sx={{ flexGrow: 1, overflowY: "auto" }}
                onNodeSelect={handleDentalTreatmentSelect}
                onNodeToggle={handleDentalTreatmentToggle}
              >
                {renderTree(denTreatmentData)}
              </TreeView>
            )}
          />

          {/* <SearchBox
            ref={treatmentRef}
            inputStyle={{ width: "100%" }}
            textField="name"
            defaultId={props.item.treatment}
            defaultText={props.item.treatment_label}
            // onGetSearchOptions={handleGetTreatmentSearchOptions}
            onSelectOption={handleOnSelectedTreatment}
          /> */}
        </div>
        <div style={{ flex: 3, display: "flex", flexDirection: "column" }}>
          <div style={{ padding: "5px 0" }}>{intl.formatMessage({ id: "cukey383" })}</div>
          <Input
            disabled={props.readonly}
            value={props.item.description}
            onChange={(e) => {
              // console.log(props.index, e.target.value);
              props.setProp(`treatmentPlanList.${props.index}.description`, e.target.value);
            }}
          />
        </div>
        <div style={{ flex: 0.2, textAlign: "center", paddingTop: "25px" }}>
          <Icon
            name="trash"
            size="large"
            color="red"
            style={{ cursor: props.readonly ? "" : "pointer" }}
            disabled={props.readonly}
            onClick={() => {
              props.onEvent({
                message: "CancelTreatmentPlan",
                params: {
                  id: props.item.id | 0,
                  planId: props.item.planId,
                  confirm: false,
                  title: props.item.treatment_label,
                },
              });
            }}
          />
        </div>
      </div>
      <div style={{ display: "flex" }}>
        <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
          <div style={{ padding: "5px 0" }}>{intl.formatMessage({ id: "cukey410" })}</div>
          <Dropdown
            selection
            disabled={props.readonly}
            options={statusOptions}
            value={props.item.status}
            onChange={(e, v) => {
              props.setProp(`treatmentPlanList.${props.index}.status`, v.value);
            }}
            style={{ minWidth: 0, margin: "2px" }}
          />
        </div>
        <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0, margin: "2px" }}>
          <div style={{ padding: "5px 0" }}>{intl.formatMessage({ id: "cukey326" })}</div>
          <Input
            disabled={props.readonly}
            value={props.item.estimate_visit}
            onChange={(e) => {
              console.log(e.target.value);
              props.setProp(`treatmentPlanList.${props.index}.estimate_visit`, e.target.value);
            }}
          />
        </div>
        <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0, margin: "2px" }}>
          <div style={{ padding: "4px 0" }}>{intl.formatMessage({ id: "cukey369" })}</div>
          <Dropdown
            selection
            disabled={props.readonly}
            options={props.urgencyOptions}
            value={props.item.urgency}
            onChange={(e, v) => {
              props.setProp(`treatmentPlanList.${props.index}.urgency`, v.value);
            }}
            style={{ minWidth: 0, margin: "2px" }}
          />
        </div>
        <div style={{ flex: 1.5, display: "flex", flexDirection: "column", minWidth: 0, margin: "2px" }}>
          <div style={{ padding: "5px 0" }}>{intl.formatMessage({ id: "cukey181" })}</div>
          {/* <Input
            value={props.item.refer_to_clinic}
            onChange={(e) => {
              console.log(e.target.value)
              props.setProp(`treatmentPlanList.${props.index}.refer_to_clinic`, e.target.value)
            }}
          /> */}
          <SearchBox
            ref={divisionRef}
            fluid={true}
            disabled={props.readonly}
            textField="name_code"
            defaultId={props.item.division}
            defaultText={props.item.division_label}
            onGetSearchOptions={handleGetDivisionSearchOptions}
            onSelectOption={handleOnSelectedDivision}
            onGetInputText={handleChangeDivision}
            isGetInputText={true}
            isDataListBottom={true}
            isError={props.errorDivsion[props.index]}
            inputStyle={{ width: "100%" }}
          />
        </div>
        <div style={{ flex: 1.5, display: "flex", flexDirection: "column", minWidth: 0, margin: "2px" }}>
          <div style={{ padding: "5px 0" }}>{intl.formatMessage({ id: "cukey313" })}</div>
          {/* <Input
            value={props.item.dentist}
            onChange={(e) => {
              console.log(e.target.value)
              props.setProp(`treatmentPlanList.${props.index}.dentist`, e.target.value)
            }}
          /> */}
          <SearchBox
            ref={doctorRef}
            fluid={true}
            disabled={props.readonly}
            textField="full_name"
            defaultId={props.item.doctor}
            defaultText={props.item.doctor_full_name}
            onGetSearchOptions={handleGetDoctorSearchOptions}
            onSelectOption={handleOnSelectedDoctor}
            onGetInputText={handleChangeDoctor}
            isGetInputText={true}
            isDataListBottom={true}
            isError={props.errorDoctor[props.index]}
            inputStyle={{ width: "100%" }}
          />
        </div>
        <div style={{ flex: 0.2 }}></div>
      </div>
    </div>
  );
};

const ItemCenter = (props: any) => {
  return <div style={{ textAlign: "center", color: props.color }}>{props.children}</div>;
};

export default TreatmentItem;
